import React from 'react';
import { Theme, makeStyles } from '@material-ui/core';
import BaseChip from '@material-ui/core/Chip';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.secondary.light,
    color: 'black',
    fontSize: '14px',
    fontWeight: 300,
    margin: 2
  }
}));

interface ChipProps {
  label: string
  onDelete?: (event: any) => void
}

const Chip: React.FC<ChipProps> = ({
  label,
  onDelete
}) => {
  const styles = useStyles();
  return (
    <BaseChip
      classes={styles}
      label={label}
      onDelete={onDelete}
    />
  );
};

export default Chip;
